module.exports = __webpack_public_path__ + "img/2c483a9.png";